(() => {
  const body = document.body;
  if (!body || body.dataset.ctModernReady === 'true') return;
  body.dataset.ctModernReady = 'true';

  const setScrolled = () => {
    body.classList.toggle('ct-page-scrolled', window.scrollY > 16);
  };

  setScrolled();
  window.addEventListener('scroll', setScrolled, { passive: true });

  const motionSelectors = [
    '.template-index #main > .shopify-section:not(.shopify-section--slideshow)',
    '.template-collection .product-list > *',
    '.template-search .product-list > *',
    '.template-product .shopify-section--related-products .product-card',
    '.template-product .shopify-section--recently-viewed-products .product-card'
  ];

  const motionItems = Array.from(document.querySelectorAll(motionSelectors.join(',')));
  if (!motionItems.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  body.classList.add('ct-motion-ready');
  motionItems.forEach((el, index) => {
    el.classList.add('ct-motion-item');
    if (index < 8) el.style.transitionDelay = `${Math.min(index * 35, 175)}ms`;
  });

  if (!('IntersectionObserver' in window)) {
    motionItems.forEach(el => el.classList.add('ct-motion-in'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('ct-motion-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '80px 0px', threshold: 0.05 });

  motionItems.forEach(el => observer.observe(el));

  /* Keyboard-friendly horizontal category rail. */
  const rail = document.querySelector('.ct-discovery-rail');
  if (rail) {
    rail.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      if (rail.scrollWidth <= rail.clientWidth) return;
      rail.scrollLeft += event.deltaY * 0.7;
    }, { passive: true });
  }
})();

/* COSMIC TRIO V7: keep product overlays below any size chart dialog. */
document.addEventListener('dialog:after-show', function (event) {
  var dialog = event.target;
  if (dialog && dialog.matches && dialog.matches('x-modal[id^="size-chart-"]')) {
    document.body.classList.add('ct-size-chart-open');
  }
});

document.addEventListener('dialog:after-hide', function (event) {
  var dialog = event.target;
  if (dialog && dialog.matches && dialog.matches('x-modal[id^="size-chart-"]')) {
    document.body.classList.remove('ct-size-chart-open');
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    var customSizeChart = document.querySelector('.singleSizeChartModal');
    if (customSizeChart && getComputedStyle(customSizeChart).display !== 'none') {
      customSizeChart.style.display = 'none';
      document.body.style.overflow = '';
      document.body.classList.remove('ct-size-chart-open');
    }
  }
});


/* COSMIC TRIO V19: product-card/PDP Wishlist Hero selected state = red heart. */
(function () {
  var selector = '.product-card__figure .wishlist-hero-custom-button, .ct-pdp-wishlist-slot .wishlist-hero-custom-button';

  function looksSelected(root) {
    if (!root) return false;
    if (root.getAttribute('aria-pressed') === 'true') return true;
    if (/active|added|selected|in-wishlist/i.test(root.className || '')) return true;
    return !!root.querySelector('[aria-pressed="true"], [class*="active" i], [class*="added" i], [class*="selected" i]');
  }

  function sync(root) {
    if (!root || !root.matches(selector)) return;
    if (looksSelected(root)) root.classList.add('ct-wishlist-red');
  }

  document.querySelectorAll(selector).forEach(sync);

  document.addEventListener('click', function (event) {
    var root = event.target.closest && event.target.closest(selector);
    if (!root) return;

    /* Immediate visual feedback; second click toggles it off. The app still owns
       the actual add/remove wishlist action. */
    root.classList.toggle('ct-wishlist-red');

    window.setTimeout(function () {
      if (looksSelected(root)) root.classList.add('ct-wishlist-red');
    }, 250);
  }, true);

  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (!target) return;
      var root = target.matches && target.matches(selector) ? target : (target.closest ? target.closest(selector) : null);
      if (root) sync(root);
      if (record.addedNodes) {
        record.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (node.matches && node.matches(selector)) sync(node);
          if (node.querySelectorAll) node.querySelectorAll(selector).forEach(sync);
        });
      }
    });
  });
  observer.observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['class','aria-pressed']});
})();
